import { mapKeys, invert } from 'lodash';

import instanceEvents from './utils/instanceEvents';

export default function renameProps(renameMap) {
  return Component => ({
    name: `${Component.name}-rename-props`,
    props: mapKeys(
      Component.props,
      (value, key) => (invert(renameMap)[key] ? invert(renameMap)[key] : key),
    ),
    render(createElement) {
      return createElement(
        Component,
        {
          props: mapKeys(this.$props, (value, key) => (renameMap[key] ? renameMap[key] : key)),
          on: {
            ...instanceEvents(this),
          },
        },
        this.$slots.default,
      );
    },
  });
}
